import { CheckBoxGenerator, EmptyColumnGenerator, FileGenerator, SelectGenerator, TextGenerator } from "../formConstantGenerator";
import { FILE } from "../formInputTypes";
import validator from "../validator";

const adminFormConstants = (roleOptions = [], readOnly = false) => {
    return [
        new TextGenerator('fName', 'First Name', readOnly, {
            required: validator.isRequired('First Name').required
        }, 4, 'text'),
        new TextGenerator('lName', 'Last Name', readOnly, {
            required: validator.isRequired('Last Name').required
        }, 4, 'text'),
        new TextGenerator('mobile', 'Contact No.', readOnly, {
            required: validator.isRequired('Contact No.').required,
            pattern: validator.isPhone
        }, 4, 'number'),
        new TextGenerator('email', 'Email', readOnly, {
            pattern: validator.isHoichoiEmail,
            required: validator.isRequired('Email').required,
        }, 4, 'email'),
        new TextGenerator('password', 'Password', readOnly, {
            required: validator.isRequired('Password').required
        }, 4, 'password'),
        new SelectGenerator('roleId', 'Choose Role', roleOptions, readOnly, {
            required: validator.isRequired('Choose Role').required
        }, 4),
    ]
}

export const adminPlanOfferFileUploadConstants = (readOnly = false) => {
    return [
        new FileGenerator('file', FILE, 'file', '.csv', 'Choose CSV file', 12, '', readOnly, null),
    ]
}

export const adminPlanOfferCodesByDateConstants = () => {
    return [
        new TextGenerator('fromDate', 'From Date', false, {
            required: validator.isRequired('From Date').required
        }, 6, 'date'),
        new TextGenerator('toDate', 'To Date', false, {
            required: validator.isRequired('To Date').required
        }, 6, 'date'),
    ]
}

export const adminDateRangeConstants = () => {
    return [
        new TextGenerator('fromDate', 'From Date', false, {
            required: validator.isRequired('Date').required
        }, 6, 'date'),
        new TextGenerator('toDate', 'To Date', false, {
            required: validator.isRequired('Date').required
        }, 6, 'date'),
    ]
}

export const mailTemplateConstants = (readOnly = false) => {
    return [
        new TextGenerator('sms_template', 'SMS Template', readOnly, {
            // required: validator.isRequired('SMS Template').required
        }, 4, 'text'),
        new TextGenerator('email_template_name', 'Email Template Name', readOnly, {
        }, 4, 'text'),
        new TextGenerator('from_email', 'From Email', readOnly, {
        }, 4, 'email'),
        new TextGenerator('sms_template_id', 'SMS Template ID', readOnly, {
            // required: validator.isRequired('SMS Template ID').required,
        }, 4, 'text'),
        // new TextGenerator('offer_identifier', 'Offer Identifier', true, {
        //     // required: validator.isRequired('Offer Identifier').required
        // }, 4, 'text'),
        new CheckBoxGenerator('var', 'Email template has custom variables?', false, readOnly, {}, 4),
        new EmptyColumnGenerator(),
        new TextGenerator('toEmail', 'To Email (for verification)', false, {}, 4, 'email'),
        new TextGenerator('toPhone', 'To Phone (for verification)', false, {}, 4, 'number'),
    ]
}

export default adminFormConstants;